import { useEffect,useState } from 'react'
import { all_routes } from '../../../router/all_routes'
import { DatePicker } from 'antd';
import CommonSelect from '../../../../core/common/commonSelect';
import { Student } from '../../../../types/dataModel';
import { isValidPhoneNumber, isValidEmail, toDateFromEpoch, isNotEmpty, toCamelCase } from '../../../../common/Utils';
import dayjs from 'dayjs';
import {API, GENDER} from '../../../../common/Constants'
import useFetch from '../../../../hooks/useFetch';
import PreLoader from '../../../../core/common/preLoader';
import { getAPIHeaders } from '../../../../common/Utils';
import FormFooter from '../../../../core/common/formFooter';
import ProfilePic from '../../../../core/common/profilePic';

type PasswordField = "password" | "confirmPassword";

interface Props {
    student?: Student
    onSuccess: ()=> void
    classOpts: any[]
}

const ModifyStudent = ({student, onSuccess, classOpts}:Props) => {
    const [formStudent, setFromStudent] = useState<Student>()
    const [msgBox, setMsgBox] = useState<any>({
      msg: "",
      error: false
    });
    const {isLoading, error, data, status, callFetch } = useFetch();
    const [defaultClass, setDefualtClass] = useState<any>()
    const [defaultGender, setDefualtGender] = useState<any>()


    useEffect(()=>{
        setFromStudent(student)
        setDefualtClass(classOpts.find((ele,idx)=> ele.value === `${student?.batchId}`))
        setDefualtGender({
          ...GENDER.find((ele) => ele.value === student?.gender)
        })
    },[student, classOpts])

    const reset = () => {
      resetMsgBox()
    }

    const resetMsgBox = () => {
      setMsgBox({
        msg: "",
        error: false
      })
    }

    const getModalContainer = () => {
        const modalElement = document.getElementById('modal-datepicker');
        return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
    };
    const [passwordVisibility, setPasswordVisibility] = useState({
        password: false,
        confirmPassword: false,
    });

    const togglePasswordVisibility = (field: PasswordField) => {
        setPasswordVisibility((prevState) => ({
        ...prevState,
        [field]: !prevState[field],
        }));
    };

    useEffect(() => {
          if(data && status && status < 299){
            setMsgBox({msg: "Updated successfully", error: false})
            onSuccess()
          }
    }, [status]);
    
    
    useEffect(() => {
        if(error){
          if(error.response?.data){
            setMsgBox({msg: error.response?.data, error: true})
          } else{
            setMsgBox({msg: 'Something went wrong please try again later.', error: true})
          }
        }
    }, [error]);
    
    const handleBasicInfoSubmit = (event: any) => {
      event.preventDefault();
      setMsgBox({ msg: "", error: false });

      if (!isNotEmpty(formStudent?.firstName)) {
        setMsgBox({ msg: "First Name is required.", error: true });
        return;
      }

      if (!isNotEmpty(formStudent?.lastName)) {
        setMsgBox({ msg: "Last Name is required.", error: true });
        return;
      }
    
      if (!isValidEmail(formStudent?.email)) {
        setMsgBox({ msg: "Email is invalid.", error: true });
        return;
      }
    
      if (!formStudent?.dob) {
        setMsgBox({ msg: "Date of Birth is required.", error: true });
        return;
      }
    
      if (!isNotEmpty(formStudent?.gender)) {
        setMsgBox({ msg: "Gender is required.", error: true });
        return;
      }
    
      if (!isValidPhoneNumber(formStudent?.phoneNumber)) {
        setMsgBox({ msg: "Please provide valid 10 digit phone number", error: true });
        return;
      }
        
      // Proceed with API call if validation passes
        callFetch(
          `${API.HRM_PROFILE}/${formStudent?.profileId}`,
          'PUT',
          getAPIHeaders(),
          null,
          {
            firstName: formStudent?.firstName,
            lastName: formStudent?.lastName,
            phoneNumber: formStudent?.phoneNumber,
            email: formStudent?.email,
            dob: formStudent?.dob,
            gender: formStudent?.gender,
          }
        );
      
    };
    

    const handleOrgSubmit = (event: any) => {
      event.preventDefault();
      setMsgBox({ msg: "", error: false });

      if (!isNotEmpty(formStudent?.batchId)) {
        setMsgBox({ msg: "Batch ID is required.", error: true });
        return;
      }
    
      callFetch(API.STUDENT, 'PUT', getAPIHeaders(), null, {
        id: formStudent?.studentBatchId,
        rollNumber: formStudent?.rollNumber,
        batchId: formStudent?.batchId,
      });
    };
    

    const handlePasswordSubmit = (event:any) => {
      event.preventDefault()
      if(formStudent?.password !== formStudent?.confirmPassword){
        setMsgBox({msg:"Password mismatch! Password and confirm password must match",error: true})
      } else {
        setMsgBox({msg:"",error: false})
        callFetch(API.PWD_RESET,
              'POST',
              getAPIHeaders(),
              null,
              {
                accountId: formStudent?.accountId,
                newPassword: formStudent?.password,
              }
          );
      }
    }



    const renderProfilePicForm = () =>{
      return (
        <ProfilePic id={formStudent?.profileId}/>
      )
    }


    const renderModifyBasicForm =() => {
      return (
        <div
        className="tab-pane fade show active"
        id="basic-info2"
        role="tabpanel"
        aria-labelledby="info-tab2"
        tabIndex={0}
      >
        <div className="modal-body pb-0 ">
          <div className="row">
            <div className="col-md-12">
              {renderProfilePicForm()}
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  First Name <span className="text-danger"> *</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={formStudent?.firstName}
                  onChange={(e)=>{setFromStudent({
                    ...formStudent,
                    firstName: e?.target?.value
                  })}}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">Last Name <span className="text-danger"> *</span></label>
                <input
                  type="email"
                  className="form-control"
                  defaultValue={formStudent?.lastName}
                  onChange={(e)=>{setFromStudent({
                    ...formStudent,
                    lastName: e?.target?.value
                  })}}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  Date of Birth <span className="text-danger"> *</span>
                </label>
                <div className="input-icon-end position-relative">
                  <DatePicker
                    className="form-control datetimepicker"
                    format={{
                      format: "DD-MM-YYYY",
                      type: "mask",
                    }}
                    getPopupContainer={getModalContainer}
                    placeholder="DD-MM-YYYY"
                    value={dayjs(toDateFromEpoch(formStudent?.dob))}
                    onChange={(dt)=>{
                      setFromStudent({
                        ...formStudent,
                        dob: dt?.toDate()?.getTime()/1000
                      })
                    }}
                  />
                  <span className="input-icon-addon">
                    <i className="ti ti-calendar text-gray-7" />
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  Gender <span className="text-danger"> *</span>
                </label>
                  <CommonSelect
                    className='select'
                    options={GENDER}
                    defaultValue={defaultGender}
                    onChange={(value) => {
                      setFromStudent({
                        ...formStudent,
                        gender: value
                      })
                    }}
                  />
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  Email <span className="text-danger"> *</span>
                </label>
                <input
                  type="email"
                  className="form-control"
                  defaultValue={formStudent?.email}
                  onChange={(e)=>{setFromStudent({
                    ...formStudent,
                    email: e?.target?.value
                  })}}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  Phone Number <span className="text-danger"> *</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={formStudent?.phoneNumber}
                  onChange={(e)=>{setFromStudent({
                    ...formStudent,
                    phoneNumber: parseInt(e?.target?.value)
                  })}}
                    onKeyPress={(e) => {
                      // Allow only numeric input
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <FormFooter
                  onCancel={reset}
                  onSave={handleBasicInfoSubmit}
                  error={msgBox.error}
                  message={msgBox.msg} 
          />
        </div>
      </div>
      )
    }

    const renderModifyOrgForm = () => {
      return (
        <div
        className="tab-pane fade show"
        id="orginfo2"
        role="tabpanel"
        aria-labelledby="org-infotab2"
        tabIndex={0}
      >
        <div className="modal-body pb-0 ">
          <div className="row">
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  Student ID <span className="text-danger"> *</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={formStudent?.batchId}
                  disabled
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">Class <span className="text-danger"> *</span></label>
                <CommonSelect
                    defaultValue={defaultClass}
                    onChange={(value: any) => {
                      setFromStudent({
                        ...formStudent,
                        batchId: parseInt(value)
                      });
                    } } 
                    options={classOpts}
                    formatOptionLabel={(item)=>{
                      return (
                        <span className='d-flex align-content-center gap-2'>
                        {item.data.batchName}-{item.data.batchSection}{"  "}
                        <span
                          className={`badge badge-xs rounded-pill bg-${item.data.curriculumStatus === "ACTIVE"
                            ? 'success' : item.data.curriculumStatus === "UPCOMING" ? 'info' : 'primary'}`}
                        >
                          {toCamelCase(item?.data.curriculumStatus)}
                        </span>
                      </span>
                      )
                    }}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">Roll Number</label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={formStudent?.rollNumber}
                  onChange={(event: any) => {
                    setFromStudent({
                      ...formStudent,
                      rollNumber: event.target.value
                    });
                  } } 
                />
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer"> 
          <FormFooter
                  onCancel={reset}
                  onSave={handleOrgSubmit}
                  error={msgBox.error}
                  message={msgBox.msg} 
          />
        </div>
      </div>
      )
    }


    const renderAuthForm = () => {
      return (
        <div
        className="tab-pane fade show"
        id="auth-info2"
        role="tabpanel"
        aria-labelledby="auth-infotab2"
        tabIndex={0}
      >
        <div className="modal-body pb-0 ">
          <div className="row">
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  Username <span className="text-danger"> *</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={formStudent?.username}
                  disabled
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3 ">
                <label className="form-label">
                  Password <span className="text-danger"> *</span>
                </label>
                <div className="pass-group">
                  <input
                    type={
                      passwordVisibility.password
                        ? "text"
                        : "password"
                    }
                    className="pass-input form-control"
                    value={formStudent?.password? formStudent?.password : ""}
                    onChange={(e)=>{setFromStudent({
                      ...formStudent,
                      password: e?.target?.value
                    })}}
                  />
                  <span
                    className={`ti toggle-passwords ${passwordVisibility.password
                      ? "ti-eye"
                      : "ti-eye-off"
                      }`}
                    onClick={() =>
                      togglePasswordVisibility("password")
                    }
                  ></span>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3 ">
                <label className="form-label">
                  Confirm Password <span className="text-danger"> *</span>
                </label>
                <div className="pass-group">
                  <input
                    type={
                      passwordVisibility.confirmPassword
                        ? "text"
                        : "password"
                    }
                    className="pass-input form-control"
                    value={formStudent?.confirmPassword ? formStudent?.confirmPassword : ""}
                    onChange={(e)=>{setFromStudent({
                      ...formStudent,
                      confirmPassword: e?.target?.value
                    })}}
                  />
                  <span
                    className={`ti toggle-passwords ${passwordVisibility.confirmPassword
                      ? "ti-eye"
                      : "ti-eye-off"
                      }`}
                    onClick={() =>
                      togglePasswordVisibility("confirmPassword")
                    }
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <FormFooter
                    onCancel={reset}
                    onSave={handlePasswordSubmit}
                    error={msgBox.error}
                    message={msgBox.msg} 
            />
        </div>
      </div> 
      )
    }

    return (
    <div className="modal fade" id="edit_employee"
      data-bs-backdrop="static"
      data-bs-keyboard="false">
       <PreLoader showLoader={isLoading} />
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <div className="d-flex align-items-center">
              <h4 className="modal-title me-2">Edit Student</h4>
              <span>Student ID : {formStudent?.studentBatchId}</span>
            </div>
            <button
              type="button"
              className="btn-close custom-btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={reset}
            >
              <i className="ti ti-x" />
            </button>
          </div>


          <form action={all_routes.employeeList}>
            <div className="contact-grids-tab">
              <ul className="nav nav-underline" id="myTab2" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="info-tab2"
                    data-bs-toggle="tab"
                    data-bs-target="#basic-info2"
                    type="button"
                    role="tab"
                    aria-selected="true"
                    onClick={resetMsgBox}
                  >
                    Basic Information
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="org-infotab2"
                        data-bs-toggle="tab"
                        data-bs-target="#orginfo2"
                        type="button"
                        role="tab"
                        aria-selected="false"
                        onClick={resetMsgBox}
                      >
                        Organizational Info
                      </button>
                </li>
                <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="auth-infotab2"
                        data-bs-toggle="tab"
                        data-bs-target="#auth-info2"
                        type="button"
                        role="tab"
                        aria-selected="false"
                        onClick={resetMsgBox}
                      >
                        Account Info
                      </button>
                </li>
              </ul>
            </div>
            <div className="tab-content" id="myTabContent2">  
              {renderModifyBasicForm()}
              {renderModifyOrgForm()}
              {renderAuthForm()}
            </div>
          </form>


        </div>
      </div>
    </div>
    )
}

export default ModifyStudent